import React from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useLocation } from "react-router";
import AsideMenuList from "./AsideMenuList";
import { useSelector, useDispatch } from "react-redux";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { UPDATE_STATUS } from '../../../../../../../../../actions/sceneActions'
import Swal from 'sweetalert2'

export function AsideMenuStudio(props) {

  const dispatch = useDispatch()

  const location = useLocation();
  const history = useNavigate();

  const { is_studio_enabled } = useSelector(state => state.studio.studioWall);

  const  wallID  = props.params.wallID ? props.params.wallID : props.params.wallId;


  let studioEnable = is_studio_enabled
  const UpdateStatusEnable = event => dispatch(UPDATE_STATUS(!studioEnable, wallID))


  const enableStudio = event => {
    Swal.fire({
      title: "Enable Studio",
      html: "<p>To Check Preview or Display You Need to Enable Studio First.<br>Otherwise You will see preview or display of your wall only.</p>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Enable",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        title: 'text-dark',
        content: 'text-dark-65 font-size-lg',
        confirmButton: 'btn btn-primary btn-min-w',
        cancelButton: 'btn btn-secondary btn-min-w'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        UpdateStatusEnable()
        Swal.fire({
          icon: 'success',
          title: 'Studio Enabled',
          showConfirmButton: false,
          timer: 1500
        })
      } else if (result.isCancel) {

      }
    })
  }


  return (<AsideMenuList layoutProps={''} location={location} history={history} wallID={wallID} />);
}
